import { colors, mixin } from "@hubrise/react-components"
import styled, { css } from "styled-components"

export const StyledTabs = styled.div`
  display: flex;
  margin-bottom: 1rem;
  gap: 0.25rem;
  flex-wrap: wrap;
`

export const Tab = styled.div<{ isActive: boolean }>`
  ${mixin.clickable};
  color: ${colors.textMedium};
  padding: 0.5rem;

  ${(props) =>
    props.isActive &&
    css`
      color: ${colors.textDark};
      border-bottom: 2px solid ${colors.textDark};
    `}
`
